import React, { useState, useMemo, useEffect } from 'react';
import { capitalize, ceil, debounce, trim } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { Tooltip, Spin, Popover } from 'antd';
import { useSelector, useDispatch } from 'react-redux';

import SideIcon from "../../../../assets/icons/side-bar-icon-blue.svg";
import DownloadICon from "../../../../assets/icons/download-icon-drop.svg"

import SearchInput from "../../../../components/uiComponent/inputs/searchinput/index";
import ReactSelect from "../../../../components/uiComponent/select/index"
import Pagination from "../../../../components/pagination/index";
import AgGrid from "../../../../components/ag-grid-table/index";
import ProgressBar from '../../../../components/uiComponent/progressBar';
import RowData from './rowData';
import Badge from '../../../../components/uiComponent/bages';
import CustomTabs from '../../../../components/uiComponent/customTabs';

import { WearHouseWorkOrderWrapper } from './style';

import { convertUtcToEst } from '../../../../utils/helpers';

import { GetWarehouseWorkOrders, GetAllUsers } from '../../../../slices/work-orders';
import { DownloadPickList } from '../../../../slices/post-shipment';
import { generateExcel, generatePDF } from '../../../../utils/download-file';
import styled from 'styled-components';

const defaultColDef = {
  resizable: true,
  sortable: false,
  filter: false,
  suppressRowClickSelection: true,
  suppressMenu: true,
};

// const statuses = [
//   { value: 'Confirmed', label: 'Confirmed' },
//   { value: 'Processed', label: 'Processed' },
//   { value: 'In Progress', label: 'In Progress' },
//   { value: 'Done', label: 'Done' }
// ];

const DropdownStyledWrapper = styled.div`
.menu-wrapper-id {
  p {
    margin: 0px;
    padding: 4px 12px;
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    vertical-align: middle;
    color: #4E5969;
    &:hover{
      background: #F5F5F5;
      cursor: pointer;
    }
}
}
`;

let gridColumnApi
const WearHouseWorkOrder = () => {
  const [page, setPage] = useState({ pageSize: 25, pageNumber: 1 });
  const [filters, setFilters] = useState({ search: '', status: '', user_id: '' });
  const [sortBy, setSortBy] = useState({ key: '', type: '' });
  const [downloadPickListLoading, setDownloadPickListLoading] = useState({});

  const [showPopover, setShowPopover] = useState(false);
const [activeStatus, setActiveStatus] = useState(null); // equivalent to isClearable select

const handleStatusTabsFilter = ({ key, value }) => {
  // You already have this function, just reuse it
  console.log(`Filter by ${key}:`, value);
   setFilters(filters => ({ ...filters, [key]: value }));
    setPage(page => ({ ...page, pageNumber: 1 }));
    dispatch(GetWarehouseWorkOrders({
      page: { ...page, pageNumber: 1 },
      filters: { ...filters, [key]: value },
      sortBy
    }));
};

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    warehouseWorkOrders,
    fetchingWarehouseWorkOrders,
    warehouseWorkOrdersCount,
    usersList,
    fetchingAllUsers,
    warehouseWorkOrderAllStatusCount
  } = useSelector((state) => state.workOrders || {});

  useEffect(() => {
    dispatch(GetWarehouseWorkOrders({ page, filters, sortBy }));
    dispatch(GetAllUsers());
  }, []);

  const downloadPickList = (data, type, id) => {
    if (!['confirmed', 'done', 'in progress', 'processed']?.includes(data?.status?.toLowerCase())) return;
    setShowPopover(false);
    setDownloadPickListLoading((prev) => ({ ...prev, [id]: true }));

    dispatch(DownloadPickList(data?.id)).then(({ payload }) => {
      if (payload?.success) {
        const { pickList = [], orderName } = payload;
        (type === 'excel' || type === 'both') && generateExcel({ pickList, orderName });
        (type === 'pdf' || type === 'both') && generatePDF({ pickList, orderName });
        setDownloadPickListLoading((prev) => ({ ...prev, [id]: false }));
      }
    });
  }

  const columnDefs = useMemo(() => [
    {
      headerName: "",
      width: 75,
      cellRenderer: "agGroupCellRenderer",
      valueGetter: (params) => params.data?.shipments?.length || 0,
      suppressRowClickSelection: true,
    },
    {
      headerName: 'Created Date',
      headerClass: 'parent-header',
      sortable: false,
      filter: true,
      minWidth: 100,
      flex: 1,
      field: 'created_at',
      cellRenderer: ({ value }) => {
        const date = convertUtcToEst(value, {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        });

        const time = convertUtcToEst(value, {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });

        return (
          <div className='date-item-wrapper'>
            <span>{date}</span>
            <span>{time}</span>
          </div>
        );
      }
    },
    {
      headerName: 'Customer Name',
      headerClass: 'parent-header',
      sortable: false,
      filter: true,
      minWidth: 214,
      flex: 1,
      cellRenderer: ({ data }) => {
        const { email, first_name } = data?.user || {};

        return (
          <div className='card-wrapper'>
            <span className='two-line-ellipsis user-name'>
              {first_name || '---'}
            </span>
            <span className='two-line-ellipsis user-email'>
              {email || '---'}
            </span>
          </div>
        )
      }
    },
    {
      headerName: 'Work Order Name',
      headerClass: 'parent-header',
      sortable: false,
      filter: true,
      minWidth: 214,
      flex: 1,
      field: 'order_name',
      cellRenderer: ({ value, data }) => {
        return (
          <div className='card-wrapper'>
            <span className='two-line-ellipsis'>
            {value ? <a href={`/shipping/${data?.id}`}>{value}</a> : '---'}
            </span>
          </div>
        )
      }
    },
    {
      headerName: 'Orders Type',
      headerClass: 'parent-header',
      sortable: false,
      filter: true,
      minWidth: 100,
      flex: 1,
      field: 'order_type',
      cellRenderer: ({ value }) => {
        return (
          <span>{ (value && value?.toUpperCase() === 'SHIP TO FBA' ? 'FBA' : 'FBM') || '---'}</span>
        )
      }
    },
    {
      headerName: 'SKUs & items',
      headerClass: 'parent-header',
      sortable: true,
      comparator: () => 0,
      filter: true,
      minWidth: 80,
      flex: 1,
      field: 'skus_count',
      cellRenderer: ({ data }) => {
        const { skus_count = 0, items_count = 0 } = data || {};
        return (
          <div className='card-wrapper gap-1'>
            <span>SKUs: {skus_count || 0}</span>
            <span>Items: {items_count || 0}</span>
          </div>
        )
      },
    },
    {
      headerName: 'Progress',
      headerClass: 'parent-header',
      sortable: true,
      filter: true,
      minWidth: 130,
      flex: 1,
      cellRenderer: ({ data }) => {
        const { shipments = [] } = data || {};
        let shipmentTotal = 0;
        let shipmentCurrent = 0;

        shipments.forEach(({ shipment_items_info = [] }) => {
          const items = Array.isArray(shipment_items_info) ? shipment_items_info : JSON.parse(shipment_items_info || '[]');
          items?.forEach(item => {
            shipmentTotal += Number(item.quantity) || 0;
            shipmentCurrent += Number(item.boxed_quantity) || 0;
          });
        });

        const total = Math.max(shipmentTotal, Number(data?.reserved_qty) || Number(data?.items_count) || 0);
        const current = Math.max(Number(data?.packed_qty) || 0, shipmentCurrent);
        let status ='grey';

        if (current === 0) {
          status = 'grey';
        }
        else if (total === current && total > 0) status = 'success'
        else if (current < total) status = 'warning'
        else status = 'warning'
        return (
          <ProgressBar simpleProgress  status={status} current={current} total={total} />
        )
      },
    },
    // {
    //   headerName: 'Ship Quantity',
    //   headerClass: 'parent-header',
    //   sortable: true,
    //   comparator: () => 0,
    //   filter: true,
    //   minWidth: 130,
    //   flex: 1,
    //   field: 'reserved_qty',
    //   cellRenderer: ({ value }) => {
    //     return (
    //       <div className='card-wrapper gap-1'>
    //         <span>{value || 0}</span>
    //       </div>
    //     )
    //   },
    // },
    // {
    //   headerName: 'Additional Information',
    //   headerClass: 'parent-header',
    //   sortable: false,
    //   filter: true,
    //   minWidth: 140,
    //   flex: 1,
    //   field: 'notes',
    //   cellRenderer: ({ value }) => {
    //     return (
    //       <div className='card-wrapper elipsises-one-line'>
    //         <Tooltip placement='top' title={value || ''}>
    //           <span>{value || '---'}</span>
    //         </Tooltip>
    //       </div>
    //     )
    //   },
    // },
    {
      headerName: 'Status',
      headerClass: 'parent-header',
      sortable: false,
      filter: true,
      minWidth: 100,
      flex: 1,
      field: 'status',
      cellRenderer: ({ value }) => {
        return (
          <Badge status={capitalize(value) || 'draft'} />
        )
      }
    },
    {
      headerName: 'Action',
      headerClass: 'parent-header',
      sortable: false,
      filter: true,
      minWidth: 100,
      flex: 1,
      cellRenderer: ({ data }) => {
        const isLoading = downloadPickListLoading[data?.id] || false;
        return (
          <Box display="flex" gap={1} alignItems="center">
            <Tooltip title='Work Order Details'>
              <img onClick={() => navigate(`/shipping/${data?.id}`)} className='cursor-pointer action-icons' src={SideIcon} />
            </Tooltip>
            <Popover
              defaultOpen={false}
              open={showPopover}
              onOpenChange={(value) => setShowPopover(value)}
              overlayClassName="file-down-loa-ded-wrapper"
              content={
                <DropdownStyledWrapper>
                  <div className="menu-wrapper-id">
                    <p
                      onClick={() => {
                        downloadPickList(data, "excel", data?.id);
                        setShowPopover(false);
                      }}
                    >
                      By Excel File
                    </p>
                    <p
                      onClick={() => {
                        downloadPickList(data, "pdf", data?.id);
                        setShowPopover(false);
                      }}
                    >
                      By PDF File
                    </p>
                  </div>
                </DropdownStyledWrapper>
              }
              placement="bottom"
            >
              <Tooltip
                title={ ['confirmed', 'done', 'in progress', 'processed']?.includes(data?.status?.toLowerCase()) ? 'Download Pick List' : 'Cannot Download While Work Order is in Draft State'}
                mouseEnterDelay={0.5}
              >
                {isLoading ? (
                  <Spin size="small" />
                ) : (
                  <img className="cursor-pointer action-icons" onClick={() => setShowPopover(true)} src={DownloadICon} />
                )}
              </Tooltip>
            </Popover>
          </Box>
        )
      }
    },
  ]);

  const handlePagination = (number, key) => {
    const value = Number(number);
    let newPage = {};

    if (key === 'pageSize') newPage = { pageNumber: 1, pageSize: value };
    else newPage = { ...page, pageNumber: value };

    setPage(newPage);
    dispatch(GetWarehouseWorkOrders({
      page: newPage,
      filters,
      sortBy
    }));
  };

  const refreshGridClick = () => {
    if (gridColumnApi) {
      gridColumnApi.applyColumnState({
        defaultState: { sort: null },
        applyOrder: true,
      });
      setSortBy({ key: '', type: '' })
    }
    dispatch(GetWarehouseWorkOrders({
      page,
      filters,
    }));
  };

  const gridReady = (params) => {
    gridColumnApi = params.columnApi
  };

  const handleStatusFilter = ({ key, value }) => {
    setFilters(filters => ({ ...filters, [key]: value }));
    setPage(page => ({ ...page, pageNumber: 1 }));
    dispatch(GetWarehouseWorkOrders({
      page: { ...page, pageNumber: 1 },
      filters: { ...filters, [key]: value },
      sortBy
    }));
  };

  const handleSearch = debounce((value) => {
    if (trim(value) || filters.search) {
      setFilters(filters => ({ ...filters, search: value }));
      setPage(page => ({ ...page, pageNumber: 1 }));
      dispatch(GetWarehouseWorkOrders({
        page: { ...page, pageNumber: 1 },
        filters: { ...filters, search: value },
        sortBy
      }));
    }
  }, 800);

  const onSortChange = (params) => {
    const value = params.columnApi.getColumnState().find(s => s.sort != null)

    if (value && ['skus_count', 'items_count', 'reserved_qty'].includes(value?.colId)) {
      const { colId, sort } = value || {};
      setSortBy({ key: colId, type: sort });
      dispatch(GetWarehouseWorkOrders({
        page,
        filters,
        sortBy: { key: colId, type: sort }
      }));
    }
  };

  const { pageSize, pageNumber } = page || {};

const statuses = [
  // {
  //   id: 'Processed',
  //   label: 'Processed',
  //   count: warehouseWorkOrderAllStatusCount['Processed'] || 0,
  //   activeBg: '#7E8A90',
  //   inactiveBg: '#7E8A9033',
  //   activeText: '#fff',
  //   inactiveText: '#7E8A90',
  //   activeCountBg: '#fff',
  //   inactiveCountBg: '',
  //   activeCountText: '#fff',
  //   inactiveCountText: '#7E8A90',
  //   activeBorder: '#7E8A90',
  //   inactiveBorder: '#7E8A90',
  //   width: 182
  // },
  {
    id: 'Confirmed',
    label: 'Confirmed',
    count: warehouseWorkOrderAllStatusCount['Confirmed'] || 0,
    activeBg: '#1565D8',
    inactiveBg: '#1565D833',
    activeText: '#fff',
    inactiveText: '#1565D8',
    activeCountBg: '#fff',
    inactiveCountBg: '',
    activeCountText: '#fff',
    inactiveCountText: '#1565D8',
    activeBorder: '#1565D8',
    inactiveBorder: '#1565D8',
    width: 182
  },
  {
    id: 'In Progress',
    label: 'In Progress',
    count: warehouseWorkOrderAllStatusCount['In Progress'] || 0,
    activeBg: '#FF9900',
    inactiveBg: '#FF99004D',
    activeText: '#fff',
    inactiveText: '#FF9900',
    activeCountBg: '#ffffff',
    inactiveCountBg: '',
    activeCountText: '#ffff',
    inactiveCountText: '#FF9900',
    activeBorder: '#FF9900',
    inactiveBorder: '#FF9900',
    width: 182
  },
  {
    id: 'Done',
    label: 'Done',
    count: warehouseWorkOrderAllStatusCount['Done'] || 0,
    activeBg: '#009C34',
    inactiveBg: '#009C3433',
    activeText: '#fff',
    inactiveText: '#009C34',
    activeCountBg: '#ffffff',
    inactiveCountBg: '',
    activeCountText: '#ffff',
    inactiveCountText: '#009C34',
    activeBorder: '#009C34',
    inactiveBorder: '#009C34',
    width: 182
  },
];


  return (
    <WearHouseWorkOrderWrapper>
      <Box display="flex" gap={2} flexDirection="row" justifyContent="space-between" alignItems="center">
        <Box display="flex" gap={2} flexDirection="row">
          <SearchInput
            placeholder="Search by Work Order Name, Type, Shipment Id, Sku, Asin & Identifier"
            classOverlay="search"
            onChange={({ target }) => handleSearch(target.value)}
          />
          <ReactSelect
            onChange={(e) => handleStatusFilter({ key: 'user_id', value: e?.value })}
            options={usersList}
            placeholder="Filter by User"
            isClearable
            loading={fetchingAllUsers}
          />
          {/* <ReactSelect
            onChange={(e) => handleStatusFilter({ key: 'status', value: e?.value })}
            options={statuses}
            placeholder="Filter by Status"
            isClearable
          /> */}
        </Box>
      </Box>
      <Box marginTop={3}>
        <Box mb={2}>
         <CustomTabs
            tabs={[
              {
                id: null,
                label: 'All',
                content: null,
                activeBg: '#1565D8',
                inactiveBg: '#E0E7FF',
                activeText: '#ffffff',
                inactiveText: '#1D4ED8',
                activeCountBg: '#ffffff',
                inactiveCountBg: '#E0E7FF',
                activeCountText: '#1D4ED8',
                inactiveCountText: '#1D4ED8',
                activeBorder: '#ffffff',
                inactiveBorder: '#1D4ED8',
                width: 100
              },
              ...statuses.map((status) => ({
                ...status,
                content: null, // no need for content in filter mode
              })),
            ]}
              activeTab={activeStatus}
              onTabClick={(id) => {
                setActiveStatus(id);
                handleStatusTabsFilter({ key: 'status', value: id });
              }}
            />
        </Box>
        <Spin tip='Loading...' spinning={fetchingWarehouseWorkOrders}>
          <AgGrid
            gridReady={gridReady}
            user_referrals={warehouseWorkOrders}
            defaultColDef={defaultColDef}
            columnDefinitions={columnDefs}
            rowHeight={64}
            headerHeight={36}
            height="234px"
            onSortChange={onSortChange}
            masterDetail={true}
            detailRowAutoHeight={true}
            detailCellRenderer={(props) => <RowData {...props} />}
            className="sku-table"
          />
          <Pagination
            total={warehouseWorkOrdersCount}
            totalPages={ceil(warehouseWorkOrdersCount / pageSize + 1)}
            pageNumber={pageNumber}
            pageLimit={pageSize}
            handleLimitChange={(e) => handlePagination(e, 'pageSize')}
            handlePageNumberChange={(e) => handlePagination(e, 'pageNumber')}
            handlePageChangeLeft={(e) => handlePagination(e, 'pageNumber')}
            handlePageChangeRight={(e) => handlePagination(e, 'pageNumber')}
            refreshGridClick={refreshGridClick}
          />
        </Spin>
      </Box>
    </WearHouseWorkOrderWrapper>
  )
}

export default WearHouseWorkOrder;
